// SPDX-License-Identifier: AGPL-3.0-or-later

export type AutoModTriggerType = 'KEYWORD' | 'MENTION_SPAM' | 'SPAM_LINK';

export type AutoModActionType = 'BLOCK_MESSAGE' | 'ALERT';

export interface AutoModRule {
	id: string;
	name: string;
	description: string;
	enabled: boolean;
	triggerType: AutoModTriggerType;
	keywords: Array<string>; // Word list or wildcard patterns (*bad*, /regex/i)
	mentionLimit: number; // Max mentions allowed before triggering (e.g. 5)
	action: AutoModActionType;
	exemptRoleIds: Array<string>;
	exemptChannelIds: Array<string>;
}

export interface AutoModConfig {
	guildId: string;
	rules: Array<AutoModRule>;
	logChannelId: string | null;
}

export interface AutoModEvaluationResult {
	blocked: boolean;
	reason?: string;
	ruleName?: string;
	matchedPattern?: string;
}

export const DEFAULT_AUTOMOD_RULES: Array<Omit<AutoModRule, 'id'>> = [
	{
		name: 'Block Phishing & Scam Links',
		description: 'Automatically blocks suspicious gift links, fake nitro drops, and credential harvesters.',
		enabled: true,
		triggerType: 'SPAM_LINK',
		keywords: [
			'discord-nitro',
			'discordgift',
			'discrod',
			'free-nitro',
			'steamcommunity-nitro',
			'roblox-robux-free',
			'gift-drop',
			'dlscord',
		],
		mentionLimit: 0,
		action: 'BLOCK_MESSAGE',
		exemptRoleIds: [],
		exemptChannelIds: [],
	},
	{
		name: 'Mention Spam Protection',
		description: 'Prevents mass-mention raids by blocking messages with excessive user or role pings.',
		enabled: true,
		triggerType: 'MENTION_SPAM',
		keywords: [],
		mentionLimit: 5,
		action: 'BLOCK_MESSAGE',
		exemptRoleIds: [],
		exemptChannelIds: [],
	},
	{
		name: 'Custom Word Blacklist',
		description: 'Blocks custom prohibited words, slurs, wildcard phrases, or regular expressions.',
		enabled: false,
		triggerType: 'KEYWORD',
		keywords: ['badword', 'example-slur'],
		mentionLimit: 0,
		action: 'BLOCK_MESSAGE',
		exemptRoleIds: [],
		exemptChannelIds: [],
	},
];
